// SubscriberTask

export const REVIEW_SUBSCRIBER_TABS_ID = 'review-subscriber-tabs';

export const SUBSCRIBER_TASK_TEST_IDS = {
  TITLE: 'subscriber-task-title-test-id',
  DESCRIPTION_VALUE: 'subscriber-task-description-value-test-id',
  STATUS_ICON: 'subscriber-task-status-icon-test-id',
  TOGGLE: 'subscriber-task-toggle-test-id',
  COLLAPSE: 'subscriber-task-collapse-test-id',
  CHEVRON_UP: 'subscriber-task-chevron-up-test-id',
  CHEVRON_DOWN: 'subscriber-task-chevron-down-test-id',
};

// EmployeeProfile

export const EMPLOYEE_PROFILE_TEST_IDS = {
  NO_ACTIVE_TASKS_MESSAGE: 'employee-profile-no-active-tasks-message-test-id',
  ACTIVE_TASKS_SECTION: 'employee-profile-active-tasks-section-test-id',
  INACTIVE_TASKS_SECTION: 'employee-profile-inactive-tasks-section-test-id',
  LOADING_SPINNER: 'employee-profile-tasks-loading-spinner-test-id',
};

// SubscriberDependentsPage

export const SUBSCRIBER_DEPENDENTS_PAGE_TEST_IDS = {
  ADD_DEPENDENT_BUTTON: 'subscriber-dependents-page-add-dependent-button-test-id',
};
